// Is the signed-in person field staff anywhere, and where do they land? (PRD 89
// §4.12, §4.14.) Read off paidBusinessStore's one business-list request, so it
// costs nothing beyond what the paywall already asks.
//
// The paywall and waitlist callers ask only for a user WITHOUT Pro (or on the
// waitlist): a Pro subscriber meets no paywall. The landing redirect asks for
// everyone in no firm, because §4.12's landing rung has no Pro exception.

import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  ensureInPaidBusinessLoaded,
  getFieldStaff,
  getFieldStaffLanding,
  subscribeInPaidBusiness,
} from '../services/paidBusinessStore';

export interface FieldStaffAnswer {
  /** Any business carries a field role; null while still being asked. */
  fieldStaff: boolean | null;
  /** '/business' when every membership is a field role; null otherwise; undefined while asked. */
  landing: string | null | undefined;
}

/** `enabled: false` answers "not field staff" without asking. */
export function useFieldStaff(enabled = true): FieldStaffAnswer {
  const { user } = useAuth();
  const uuid = user?.uuid;
  const authToken = enabled ? user?.authToken : undefined;

  const read = (): FieldStaffAnswer => ({ fieldStaff: getFieldStaff(uuid), landing: getFieldStaffLanding(uuid) });
  const [answer, setAnswer] = useState<FieldStaffAnswer>(read);

  useEffect(() => {
    if (!authToken) return undefined;
    const unsubscribe = subscribeInPaidBusiness(() =>
      setAnswer({ fieldStaff: getFieldStaff(uuid), landing: getFieldStaffLanding(uuid) })
    );
    ensureInPaidBusinessLoaded(uuid);
    setAnswer({ fieldStaff: getFieldStaff(uuid), landing: getFieldStaffLanding(uuid) });
    return unsubscribe;
  }, [authToken, uuid]);

  if (!authToken) return { fieldStaff: false, landing: null };
  return answer;
}
